import { useState } from 'react';
import { useForm } from 'react-hook-form';
import SuccessErrorMsg from "../../../../utilities/SuccessErrorMsg"
import { handleImageChange } from "../../../../utilities/handleFunctions/HandelImageChange"
import { afterTodayDate, todayDate } from "../../../../utilities/validations/dateValidations";
import { toast, ToastContainer } from "react-toastify";
import { editAdminOffersform } from '../../../../hooks/apiAxios';
import moment from 'moment';
import { RiyalImgBLK } from '../../../../components/common/RiyalImg';


export function OffersModify({ offerId, offerImgAlt, offerImage, OfferNameAr, offerNameEn, startDate, endDate, originalPrice, discountedPrice, isAvailable, descriptionAr, descriptionEn, OffersampleImg }) {
    const [image, setImage] = useState(offerImage);
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();

    // const [dataUpdate, setDataUpdate] = useState(false);
    const [loading, setLoading] = useState(false);

    moment.locale('en');

    const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    async function onSubmit(data) {
        setLoading(true);
        console.log(data);


        const formData = new FormData();

        formData.append("nameAr", data.nameAr);
        formData.append("nameEn", data.nameEn);
        formData.append("startDate", moment(data.startDate).toISOString());
        formData.append("endDate", moment(data.endDate).toISOString());
        formData.append("originalPrice", data.originalPrice);
        formData.append("discountedPrice", data.discountedPrice);
        formData.append("isAvailable", data.isAvailable);
        formData.append("descriptionAr", data.descriptionAr);
        formData.append("descriptionEn", data.descriptionEn);
        formData.append("image", data.image);

        try {
            const response = await editAdminOffersform(offerId, formData);

            if (response.data.isSuccess) {
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
                toast.success("تم تعديل العرض بنجاح");
            } else {
                toast.error("حدث خطأ ما، حاول مرة أخرى");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.error("حدث خطأ ما، تواصل مع الدعم");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div id={`Offer_${offerId}`}
            className="modal fade bg-transparent"
            tabIndex="-1"
            aria-hidden="true"
            aria-labelledby="OffersEditForm"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="OffersEditForm">عرض رقم - {offerId}</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-0">

                        <form
                            encType="multipart/form-data"
                            method="patch"
                            className='d-flex flex-column flex-md-row shadow mx-auto gap-2 text-start bg-white px-2 pb-4 rounded align-items-center'
                            onSubmit={handleSubmit(onSubmit)}>

                            <div className="book-image-container position-relative m-auto mt-3 mt-md-5 ms-md-2">
                                <img className="book-image mx-auto w-100"
                                    crossOrigin="anonymous"
                                    src={image ? image : OffersampleImg} alt={offerImgAlt}
                                />
                                <h6 className="book-change-text border text-center">تغير الصورة</h6>
                                <input
                                    className="opacity-0 profile-image-input"
                                    type="file"
                                    accept="image/jpeg"
                                    // onChange={(e) => handleBookImageChange(e, setValue, setImage)}
                                    onChange={(e) => handleImageChange(e, setValue, setImage)}
                                />
                            </div>

                            <div className="d-flex flex-column col-11 col-md-8 ms-4 mb-5 my-md-5 gap-1">

                                {/* Input fields */}

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">العرض</span>
                                    <input
                                        className={`form-control ${errors.nameAr && "border border-danger"}`}
                                        type="text"
                                        defaultValue={OfferNameAr}
                                        // onChange={(e) => { setValue("title", e.target.value) }}
                                        {...register("nameAr", { required: true, minLength: 10 })}
                                    />
                                    {errors.nameAr && <p className='errors-msg'>الاسم مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">Offer</span>
                                    <input
                                        className={`form-control ${errors.nameEn && "border border-danger"}`}
                                        type="text"
                                        defaultValue={offerNameEn}
                                        // onChange={(e) => { setValue("title", e.target.value) }}
                                        {...register("nameEn", { required: true, minLength: 10 })}
                                    />
                                    {errors.name && <p className='errors-msg'>الاسم مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >السعر قبل</span>
                                    <input className='form-control text-start'
                                        type="number" step="any"
                                        placeholder="ضع السعر شامل الضريبة"
                                        defaultValue={originalPrice}
                                        name='originalPrice'
                                        required
                                        {...register("originalPrice", { required: true })}
                                    />
                                    <span className="input-group-text" ><RiyalImgBLK /></span>

                                    {errors.originalPrice && <p className='errors-msg'>أدخل رقم فقط</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >السعر بعد</span>
                                    <input className='form-control text-start'
                                        type="number" step="any"
                                        placeholder="ضع السعر شامل الضريبة"
                                        defaultValue={discountedPrice}
                                        name='discountedPrice'
                                        required
                                        {...register("discountedPrice", { required: true })}
                                    />
                                    <span className="input-group-text" ><RiyalImgBLK /></span>

                                    {errors.discountedPrice && <p className='errors-msg'>أدخل رقم فقط</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >تاريخ البداية</span>
                                    <input
                                        className='form-control text-start'
                                        type="date"
                                        defaultValue={formattedStartDate}
                                        min={todayDate}
                                        name='startDate'
                                        {...register("startDate", { required: true })}
                                    // onChange={(e) => { setValue("startDate", e.target.value) }}
                                    />
                                    {errors.startDate && <p className='errors-msg'>تاريخ البداية مطلوب</p>}
                                </div>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >تاريخ النهاية</span>
                                    <input
                                        className='form-control text-start'
                                        type="date"
                                        defaultValue={formattedEndDate}
                                        min={afterTodayDate}
                                        {...register("endDate", { required: true })}

                                    // onChange={(e) => { setValue("endDate", e.target.value) }}
                                    />
                                    {errors.endDate && <p className='errors-msg'>تاريخ النهاية مطلوب</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text" >حالة العرض</span>
                                    <select className='form-select text-start'
                                        {...register("isAvailable")}
                                        defaultValue={isAvailable}
                                    >
                                        <option value={true}>تشغيل</option>
                                        <option value={false}>إيقاف</option>
                                    </select>
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">تفاصيل</span>
                                    <textarea
                                        className={`form-control ${errors.descriptionAr && "border border-danger"}`}
                                        type="textArea"
                                        rows="5"
                                        // onChange={(e) => { setValue("description", e.target.value) }}
                                        defaultValue={descriptionAr}
                                        placeholder='تفاصيل الخدمة'
                                        // required
                                        {...register("descriptionAr", { minLength: 10 })} />
                                    {errors.descriptionAr && <p className='errors-msg'> مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                                <div className="input-group input-group-sm">
                                    <span className="input-group-text">Details</span>
                                    <textarea
                                        className={`form-control ${errors.description && "border border-danger"}`}
                                        type="textArea"
                                        rows="7"
                                        onChange={(e) => { setValue("descriptionEn", e.target.value) }}
                                        defaultValue={descriptionEn}
                                        placeholder='Details'
                                        {...register("descriptionEn", { required: true, minLength: 10 })} />
                                    {errors.description && <p className='errors-msg'> مطلوب أكبر من ١٠ أحرف</p>}
                                </div>

                            </div>
                            <button
                                className='btn btn-dark-orange text-white col-2 me-3 mb-3 position-absolute bottom-0 end-0'
                                type="submit">
                                {loading &&
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"></span>
                                }
                                حفظ
                            </button>
                        </form>
                        <SuccessErrorMsg
                            ToastContainer={ToastContainer}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}